<template>
  <form @submit.prevent="onSubmit">
    <div class="wizard-header">
      <h3 class="wizard-title">{{ wizardTitle }}</h3>
      <p class="category">{{ wizardDescription }}</p>
    </div>

    <insurers></insurers>

    <wizard-navigation :step="step"></wizard-navigation>

    <div class="tab-content details-tab-content">
      <div
        class="tab-pane"
        v-bind:class="{ active: step == 2 }"
        v-if="step == 2"
      >
        <error-message></error-message>

        <div class="row">
          <div class="col-sm-12">
            <h5 class="info-text">{{ infoText }}</h5>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-sm-10 col-sm-offset-1">
            <div class="form-group">
              <label>
                Business Name
                <span class="required-field">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                v-model="fields.business_name"
                placeholder="Your Business Name..."
                maxlength="190"
              />
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-sm-5 col-sm-offset-1">
            <div class="form-group">
              <label>
                Full Name
                <span class="required-field">*</span>
              </label>
              <div class="row px-3">
                <input
                  type="text"
                  class="form-control col-6"
                  v-model="fields.first_name"
                  placeholder="Your First Name..."
                  maxlength="190"
                />
                <input
                  type="text"
                  class="form-control col-6"
                  v-model="fields.last_name"
                  placeholder="Your Last Name..."
                  maxlength="190"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-5">
            <div class="form-group">
              <label>
                Date of Birth
                <span class="required-field">*</span> (eg: dd/mm/yyyy)
              </label>
              <div class="inline-div">
                <date-pick
                  class="form-control col d-flex"
                  required
                  :inputAttributes="{ placeholder: 'eg: dd/mm/yyyy' }"
                  :isDateDisabled="isDateDisabled"
                  v-model="fields.dob"
                  :format="'DD/MM/YYYY'"
                  :startWeekOnSunday="false"
                  :startPeriod="dobStartDate"
                ></date-pick>
                <!-- <input
                  type="number"
                  step="1"
                  min="1"
                  max="31"
                  @blur="validateDate"
                  v-model="fields.date"
                  class="form-control"
                  placeholder="dd"
                  style="width:33%;float: left;"
                  pattern="[0-9]*"
                  ref="dobDate"
                />
                <input
                  type="number"
                  step="1"
                  min="1"
                  max="12"
                  @blur="validateMonth"
                  v-model="fields.month"
                  class="form-control"
                  placeholder="mm"
                  style="width:33%;float: left;"
                  pattern="[0-9]*"
                  ref="dobMonth"
                />
                <input
                  type="number"
                  step="1"
                  min="1900"
                  max="2500"
                  @blur="validateYear"
                  v-model="fields.year"
                  class="form-control"
                  placeholder="yyyy"
                  style="width:33%;float: left;"
                  pattern="[0-9]*"
                  ref="dobYear"
                /> -->
              </div>
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-sm-5 col-sm-offset-1">
            <div class="form-group">
              <label>
                Mobile Phone Number
                <span class="required-field">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                v-model="fields.phone"
                placeholder="Your Mobile Number..."
                maxlength="190"
              />
            </div>
          </div>

          <div class="col-sm-5">
            <div class="form-group">
              <label>
                Email Address
                <span class="required-field">*</span>
              </label>
              <input
                type="email"
                v-model="fields.email"
                class="form-control"
                placeholder="Your Full Email Address..."
                maxlength="190"
              />
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-sm-10 col-sm-offset-1">
            <div class="form-group">
              <label>
                Gender
                <span class="required-field">*</span>
              </label>
              <br />
              <div class="btn-group push-15 btn-group-justified">
                <div class="btn-group">
                  <button
                    type="button"
                    class="btn b-r-0"
                    :class="{
                      'btn-selected btn-fill btn-primary':
                        fields.gender == 'male',
                    }"
                    @click="fields.gender = 'male'"
                  >
                    Male
                  </button>
                </div>
                <div class="btn-group">
                  <button
                    type="button"
                    class="btn"
                    :class="{
                      'btn-selected btn-fill btn-primary':
                        fields.gender == 'female',
                    }"
                    @click="fields.gender = 'female'"
                  >
                    Female
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="row justify-content-center"
          v-if="
            !isUnavailableOccupation &&
            totalCostOfInsurance !== null &&
            totalCostOfInsurance !== 0
          "
        >
          <div class="col-sm-10 col-sm-offset-1 py-5">
            <div
              class="panel panel-default p-l-15 p-r-15"
              style="background: #f0f0f0"
            >
              <div class="panel-body">
                <h5 class="info-text m-b-0-i">
                  Lowest Total Cost of Insurance Cover
                  <span>from {{ getUndewriterName }}</span>
                </h5>
                <h3
                  class="m-b-10 text-center"
                  style="color: #00a99d"
                  v-text="'$' + totalCostOfInsurance.toFixed(2)"
                />
                <div class="row">
                  <div class="col-sm-5 mx-auto">
                    <cost-breakdown-summary />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="wizard-footer" style="padding-top: 20px">
      <div class="clearfix"></div>
      <div class="pull-right">
        <button
          type="button"
          class="btn btn-next btn-fill btn-success btn-wd"
          :disabled="!enableNextButton"
          @click="submitForm()"
        >
          Get My Quote
          <i class="fa fa-arrow-right"></i>
        </button>
      </div>
      <div class="pull-left">
        <button
          type="button"
          class="btn btn-previous btn-default btn-wd"
          @click="previousClicked"
        >
          <i class="fa fa-arrow-left"></i> Back
        </button>
      </div>
      <div class="clearfix"></div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { EventBus } from "../event-bus";
import store from "../store";
import * as appConfigs from "../configs";
import {
  generateErrorMessage,
  formValidate,
  requireHeatWorkPercentage,
} from "../helpers";
import Cookies from "js-cookie";
import { isEmpty, includes } from "lodash";
import axios from "axios";
import CostBreakdownSummary from "./CostBreakdownSummary.vue";
import WizardNavigation from "./WizardNavigation";
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";

export default {
  components: {
    CostBreakdownSummary,
    DatePick,
    WizardNavigation,
  },
  data: function () {
    return {
      step: 2,
      // fields needed to be post to api end point
      fields: {
        postcode_of_risk: "",
        current_annual_revenue: "",
        occupation_id: "",
        business_name: "",
        name: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        dob: "",
        gender: "",
        id: null,
        email: "",
        head_count: "",
        percentage_of_insured_turnover_from_premises: "",
        percentage_of_insured_turnover_from_by_sub_contractors: "",
        period_of_cover: "12",
        limits_required: appConfigs.defaultAmountOption,
        deductible: "1000",
        amount_options: appConfigs.amountOptions,
        deductible_options: appConfigs.deductibleOptions.def,
        referral: "",
        agreed_to_declaration: null,
      },
      disabled: false,
    };
  },
  props: {
    wizardTitle: {
      type: String,
      required: true,
    },
    wizardDescription: {
      type: String,
      required: true,
    },
    infoText: {
      type: String,
      required: true,
    },
  },
  watch: {
    serializedFields: function () {
      this.disabled = false;
    },
  },
  computed: {
    ...mapState({
      configs: (state) => state.configs,
      quoteRejected: (state) => state.quoteRejected,
      summaryData: (state) => state.summaryData,
      customerEmail: (state) => state.customerEmail,
      accidentCover: (state) => state.accidentCover,
      unavailableOccupations: (state) => state.unavailableOccupations,
      pendingOrder: (state) => state.pendingOrder,
    }),
    ...mapGetters(["totalCostOfInsurance", "cheapestCostUnderwriterName"]),
    pendingOrderId() {
      return Cookies.get("pendingOrderId") || this.pendingOrder?.id;
    },
    serializedFields() {
      return JSON.stringify(this.fields);
    },
    getUndewriterName() {
      return this.cheapestCostUnderwriterName;
    },
    enableNextButton() {
      return true;
      // only all values are filled, the next button can be clicked
      return this.isValidForm && !this.quoteRejected && !this.disabled;
    },
    isValidForm() {
      const errors = formValidate(this.fields, {
        percentage_of_insured_turnover_from_premises:
          this.requireHeatWorkPercentage,
      });
      // this.$store.commit('setErrors', { errors })
      return isEmpty(errors);
    },
    requireHeatWorkPercentage() {
      return requireHeatWorkPercentage(
        this.fields.occupation_id,
        this.configs.occupations
      );
    },
    showInReferral() {
      return (
        Cookies.get("convertFromReferral") != this.pendingOrder.id &&
        this.pendingOrder.in_referral
      );
    },

    showUnavailableOccupation() {
      if (
        includes(this.unavailableOccupations, this.pendingOrder.occupation_id)
      ) {
        return false;
      } else {
        return true;
      }
    },
    isUnavailableOccupation() {
      if (
        includes(this.unavailableOccupations, this.pendingOrder.occupation_id)
      ) {
        return true;
      } else {
        return false;
      }
    },
    dobStartDate(date) {
      let currentDate = new Date();
      let currentYear = currentDate.getFullYear();
      return { month: currentDate.getMonth(), year: currentYear - 18 };
    },
   
  },
  mounted() {
    // not the best solution, but due to some unknow issue,
    // if the vm.checkAndLoadPendingOrder() was called
    // directly, sometimes vue fields data was initalized , sometimes not
    // setTimeout(function(){ vm.checkAndLoadPendingOrder() }, 1000)
    this.checkAndLoadPendingOrder();

    this.$store.dispatch("loadConfigs");
  },
  methods: {
    ...mapActions({
      scrollToTop: "scrollToTop",
      loadPendingOrder: "loadPendingOrder",
      calculate: "calculate",
    }),
    // async getUnavailableOccupations() {
    //   var $this = this;
    //   await axios.get(appConfigs.getAllUnavailableOccupationsUrl).then((res) => {
    //     console.log(res.data);
    //     $this.$store.commit("setUnavailableOccupations", res.data.occupations);
    //   });
    // },
    checkAndLoadPendingOrder() {
      if (!this.pendingOrder?.id) {
        return;
      }

      const fields = Object.keys(this.fields);
      const orderId = this.pendingOrder.id;

       if (orderId == undefined || orderId == null) {
        return;
      }
      

      this.$store.commit("setScreenLoader", { showScreenLoader: true });

      this.loadPendingOrder({ orderId, fields })
        .then((data) => {
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
          this.fields = Object.assign({}, this.fields, data);

          // splitting name
          if (this.fields != undefined && this.fields.name !== null) {
            var name = this.fields.name.split(" ");
            this.fields.first_name = name[0];
            this.fields.last_name = name[1] !== undefined ? name[1] : "";
          }
          this.calculate(this.fields);
        })
        .catch(() => {
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
        });
    },

    isDateDisabled(date) {
      let currentDate = new Date();
      let currentYear = currentDate.getFullYear();
      let allowedYear = new Date(
        currentYear - 18,
        currentDate.getMonth(),
        currentDate.getDate()
      );

      return date > allowedYear;
    },

    pad(n, width, z) {
      z = z || "0";
      n = n + "";
      return n.length >= width
        ? n
        : new Array(width - n.length + 1).join(z) + n;
    },
    submitForm() {
      if (!this.enableNextButton) {
        return;
      }
      this.$store.commit("setScreenLoader", { showScreenLoader: true });
      // this.fields.dob =
      //   this.pad(this.fields.date, 2) + "-" + this.pad(this.fields.month,2) + "-" + this.pad(this.fields.year, 4);
      this.fields.name = this.fields.first_name + " " + this.fields.last_name;

      axios
        .post(appConfigs.validateUrl, {
          ...this.fields,
          id: this.pendingOrderId,
          step: this.step,
        })
        .then(({ data = {} } = {}) => {
          const pendingOrder = data.data.pendingOrder || this.pendingOrder;
          this.$store.commit("clearError");
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
          this.$store.commit("setPendingOrder", { pendingOrder });

          // If a customer used a business name or an email that is already in DB
          // show a popup saying that an account with this details already
          // exists and they should use different details
          if (data.status === "error") {
            const errorMessage = generateErrorMessage(data.message);
            this.$store.commit("setError", { error: errorMessage });
            this.disabled = true;
          } else {
            this.$store.commit("incrementStep");
          }

          this.scrollToTop();
        })
        .catch((error) => {
          const errorMessage = generateErrorMessage(error);
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
          this.$store.commit("setError", { error: errorMessage });
          this.disabled = true;
        });
    },
    previousClicked() {
      this.$store.commit("decrementStep");
      this.$store.commit("clearError");
      this.scrollToTop();
    },
    validateCharacters(e) {
      // Create special characters regex test (only allow letters, numbers and space)
      let regex = new RegExp("^[a-zA-Z0-9 ]+$");

      if (!regex.test(e.key)) {
        // Prevent typing if test fails
        return e.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../sass/form/global";

.details-tab-content {
  min-height: 0px !important;
}

.xmx-input {
  outline: none !important;
  background-color: transparent !important;
  border: 0 !important;
  border-radius: 4px;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.vdpComponent {
  padding: 0px !important;
}
.vdpComponent input {
  width: 100% !important;
  background-color: #fff !important;
  border: medium none !important;
  border-radius: 4px !important;
  color: #66615b !important;
  font-size: 16px !important;
  transition: background-color 0.3s ease 0s !important;
  padding: 7px 18px !important;
  height: 40px !important;
  box-shadow: none !important;
}
.vdpArrowPrev:after {
  border-right-color: #009245;
}

.vdpArrowNext:after {
  border-left-color: #009245;
}

.vdpCell.selectable:hover .vdpCellContent,
.vdpCell.selected .vdpCellContent {
  background: #009245;
}

.vdpCell.today {
  color: #009245;
}

.vdpTimeUnit > input:hover,
.vdpTimeUnit > input:focus {
  border-bottom-color: #009245;
}

.vdpRow .disabled {
  color: #fff !important;
  display: table-cell !important;
}

.btn-previous {
  border-radius: 5px !important;
}
.b-r-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>
